<template>
  <div>
    <v-container class="hidden-print-only">
      <v-row no-gutters>
        <v-col cols="12" class="text-right">
          <v-btn depressed color="primary" class="ma-2" @click="isShowTable = !isShowTable">
            <v-icon v-if="!isShowTable">view_list</v-icon>
            <v-icon v-else>mail</v-icon>
          </v-btn>
          <v-btn depressed color="primary" class="my-2" @click="printSaleVoucher">
            <v-icon>print</v-icon>
          </v-btn>
        </v-col>
        <v-col v-if="!isShowTable" cols="12" class="box">
          <v-row no-gutters>
            <v-col md="2" cols="4">
              <img :src="file" ref="cropper" style="height: 19vh;" />
            </v-col>
            <v-col md="6" cols="8" class="text-left px-3">
              <v-row no-gutters>
                <v-col cols="12" class="display-2 first-heading-font">{{company.companyName}}</v-col>
                <v-col cols="12">{{company.address}}</v-col>
                <v-col cols="12">{{company.phoneNo}}</v-col>
                <v-col cols="12">{{company.email}}</v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="11" class="text-right">{{todayDate}}</v-col>
            <v-col cols="8" class="text-left">
              <v-row no-gutters class="pb-4">
                <v-col cols="12">From</v-col>
                <v-col
                  cols="12"
                  class="font-weight-black"
                >{{voucherDetail.osName}} (Ph : {{voucherDetail.osPhone}})</v-col>
                <v-col
                  cols="12"
                >{{voucherDetail.osAddress}} {{voucherDetail.osTownship}} {{voucherDetail.osCity}}</v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12">To</v-col>
                <v-col
                  cols="12"
                  class="font-weight-black"
                >{{voucherDetail.customerName}} (Ph : {{voucherDetail.customerPhone}})</v-col>
                <v-col
                  cols="12"
                >{{voucherDetail.customerAddress}} {{voucherDetail.fromBranchName}} {{voucherDetail.fromBranchAddress}}</v-col>
              </v-row>
            </v-col>
            <v-col cols="4" class="text-center">
              <table class="envlope">
                <tr>
                  <th>Item Name</th>
                  <td class="pa-2">{{voucherDetail.itemName}}</td>
                </tr>
                <tr>
                  <th>Item Weight</th>
                  <td class="pa-2">{{voucherDetail.weight}}</td>
                </tr>
                <tr>
                  <th>Item Value</th>
                  <td class="pa-2">{{voucherDetail.itemValue}}</td>
                </tr>
                <tr>
                  <th>Delivery Fee</th>
                  <td class="pa-2">{{voucherDetail.deliCost}}</td>
                </tr>
                <tr>
                  <th>Payment</th>
                  <td class="pa-2">{{voucherDetail.cutomerPayment}}</td>
                </tr>
              </table>
            </v-col>
            <v-col cols="6" class="text-left pt-2">{{itemId}}</v-col>
            <v-col cols="6" class="text-right pt-2">Issued by - {{profileName}}</v-col>
          </v-row>
        </v-col>
        <v-col v-else cols="12">
          <v-container class="pt-0 py-0">
            <v-row no-gutters>
              <v-col cols="12">
                <v-row no-gutters>
                  <v-col md="2" cols="2">
                    <img :src="file" ref="cropper" style="height: 19vh;" />
                  </v-col>
                  <v-col md="6" cols="8" class="text-left px-3">
                    <v-row no-gutters>
                      <v-col cols="12" class="display-2 first-heading-font">{{company.companyName}}</v-col>
                      <v-col cols="12">{{company.address}}</v-col>
                      <v-col cols="12">{{company.phoneNo}}</v-col>
                      <v-col cols="12">{{company.email}}</v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" class="text-right">{{todayDate}}</v-col>
              <v-col cols="6" class="pr-1">
                <table>
                  <thead>
                    <tr>
                      <th>From</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{voucherDetail.osName}}</td>
                    </tr>
                    <tr>
                      <td>(Ph : {{voucherDetail.osPhone}})</td>
                    </tr>
                    <tr>
                      <td>{{voucherDetail.osAddress}} {{voucherDetail.osTownship}} {{voucherDetail.osCity}}</td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
              <v-col cols="6" class="pl-1">
                <table>
                  <thead>
                    <tr>
                      <th>To</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{voucherDetail.customerName}}</td>
                    </tr>
                    <tr>
                      <td>(Ph : {{voucherDetail.customerPhone}})</td>
                    </tr>
                    <tr>
                      <td>{{voucherDetail.customerAddress}} {{voucherDetail.fromBranchName}} {{voucherDetail.fromBranchAddress}}</td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
              <v-col cols="12" class="mt-2">
                <table class="envlope">
                  <tr>
                    <th style="width: 25%">Item Name</th>
                    <td class="pa-2">{{voucherDetail.itemName}}</td>
                  </tr>
                  <tr>
                    <th>Item Weight</th>
                    <td class="pa-2">{{voucherDetail.weight}}</td>
                  </tr>
                  <tr>
                    <th>Item Value</th>
                    <td class="pa-2">{{voucherDetail.itemValue}}</td>
                  </tr>
                  <tr>
                    <th>Delivery Fee</th>
                    <td class="pa-2">{{voucherDetail.deliCost}}</td>
                  </tr>
                  <tr>
                    <th>Payment</th>
                    <td class="pa-2">{{voucherDetail.cutomerPayment}}</td>
                  </tr>
                </table>
              </v-col>

              <v-col cols="6" class="text-left">{{itemId}}</v-col>
              <v-col cols="6" class="text-right">Issued by - {{profileName}}</v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <!-- d-print-block d-none -->
    <div class="d-print-block d-none">
      <v-row no-gutters v-if="!isShowTable">
        <v-col class="pa-2" cols="12">
          <div class="box">
            <v-row no-gutters class="caption">
              <v-col md="2" cols="2">
                <img :src="file" ref="cropper" style="height: 10vh;" />
              </v-col>
              <v-col md="6" cols="8" class="text-left px-3">
                <v-row no-gutters>
                  <v-col cols="12" class="first-heading-font">{{company.companyName}}</v-col>
                  <v-col cols="12">{{company.address}}</v-col>
                  <v-col cols="12">{{company.phoneNo}}</v-col>
                  <v-col cols="12">{{company.email}}</v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters class="fontCss">
              <v-col cols="11" class="text-right">{{todayDate}}</v-col>
              <v-col cols="6" class="text-left">
                <v-row no-gutters class="pb-4">
                  <v-col cols="12">From</v-col>
                  <v-col
                    cols="12"
                    class="font-weight-black"
                  >{{voucherDetail.osName}} (Ph : {{voucherDetail.osPhone}})</v-col>
                  <v-col
                    cols="12"
                  >{{voucherDetail.osAddress}} {{voucherDetail.osTownship}} {{voucherDetail.osCity}}</v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12">To</v-col>
                  <v-col
                    cols="12"
                    class="font-weight-black"
                  >{{voucherDetail.customerName}} (Ph : {{voucherDetail.customerPhone}})</v-col>
                  <v-col
                    cols="12"
                  >{{voucherDetail.customerAddress}} {{voucherDetail.fromBranchName}} {{voucherDetail.fromBranchAddress}}</v-col>
                </v-row>
              </v-col>
              <v-col cols="6" class="text-center">
                <table class="envlope">
                  <tr>
                    <th>Item Name</th>
                    <td class="pa-1">{{voucherDetail.itemName}}</td>
                  </tr>
                  <tr>
                    <th>Item Weight</th>
                    <td class="pa-1">{{voucherDetail.weight}}</td>
                  </tr>
                  <tr>
                    <th>Item Value</th>
                    <td class="pa-1">{{voucherDetail.itemValue}}</td>
                  </tr>
                  <tr>
                    <th>Delivery Fee</th>
                    <td class="pa-1">{{voucherDetail.deliCost}}</td>
                  </tr>
                  <tr>
                    <th>Payment</th>
                    <td class="pa-1">{{voucherDetail.cutomerPayment}}</td>
                  </tr>
                </table>
              </v-col>
              <v-col cols="6" class="text-left pt-2 fontCss">{{itemId}}</v-col>
              <v-col cols="6" class="text-right pt-2">Issued by - {{profileName}}</v-col>
            </v-row>
          </div>
        </v-col>
        <v-col class="pa-2" cols="12">
          <div class="box">
            <v-row no-gutters class="caption">
              <v-col md="2" cols="2">
                <img :src="file" ref="cropper" style="height: 10vh;" />
              </v-col>
              <v-col md="6" cols="8" class="text-left px-3">
                <v-row no-gutters>
                  <v-col cols="12" class="first-heading-font">{{company.companyName}}</v-col>
                  <v-col cols="12">{{company.address}}</v-col>
                  <v-col cols="12">{{company.phoneNo}}</v-col>
                  <v-col cols="12">{{company.email}}</v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters class="fontCss">
              <v-col cols="11" class="text-right">{{todayDate}}</v-col>
              <v-col cols="6" class="text-left">
                <v-row no-gutters class="pb-4">
                  <v-col cols="12">From</v-col>
                  <v-col
                    cols="12"
                    class="font-weight-black"
                  >{{voucherDetail.osName}} (Ph : {{voucherDetail.osPhone}})</v-col>
                  <v-col
                    cols="12"
                  >{{voucherDetail.osAddress}} {{voucherDetail.osTownship}} {{voucherDetail.osCity}}</v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12">To</v-col>
                  <v-col
                    cols="12"
                    class="font-weight-black"
                  >{{voucherDetail.customerName}} (Ph : {{voucherDetail.customerPhone}})</v-col>
                  <v-col
                    cols="12"
                  >{{voucherDetail.customerAddress}} {{voucherDetail.fromBranchName}} {{voucherDetail.fromBranchAddress}}</v-col>
                </v-row>
              </v-col>
              <v-col cols="6" class="text-center">
                <table class="envlope">
                  <tr>
                    <th>Item Name</th>
                    <td style="fontsize: 0.50rem;">{{voucherDetail.itemName}}</td>
                  </tr>
                  <tr>
                    <th>Item Weight</th>
                    <td>{{voucherDetail.weight}}</td>
                  </tr>
                  <tr>
                    <th>Item Value</th>
                    <td>{{voucherDetail.itemValue}}</td>
                  </tr>
                  <tr>
                    <th>Delivery Fee</th>
                    <td>{{voucherDetail.deliCost}}</td>
                  </tr>
                  <tr>
                    <th>Payment</th>
                    <td>{{voucherDetail.cutomerPayment}}</td>
                  </tr>
                </table>
              </v-col>
              <v-col cols="6" class="text-left pt-2 fontCss">{{itemId}}</v-col>
              <v-col cols="6" class="text-right pt-2">Issued by - {{profileName}}</v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <v-row no-gutters class="caption">
            <v-col md="2" cols="2">
              <img :src="file" ref="cropper" style="height: 10vh;" />
            </v-col>
            <v-col md="6" cols="8" class="text-left px-3">
              <v-row no-gutters>
                <v-col cols="12" class="first-heading-font">{{company.companyName}}</v-col>
                <v-col cols="12">{{company.address}}</v-col>
                <v-col cols="12">{{company.phoneNo}}</v-col>
                <v-col cols="12">{{company.email}}</v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6" class="caption pr-1">
              <table>
                <thead>
                  <tr>
                    <th>From</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{voucherDetail.osName}}</td>
                  </tr>
                  <tr>
                    <td>(Ph : {{voucherDetail.osPhone}})</td>
                  </tr>
                  <tr>
                    <td>{{voucherDetail.osAddress}} {{voucherDetail.osTownship}} {{voucherDetail.osCity}}</td>
                  </tr>
                </tbody>
              </table>
            </v-col>
            <v-col cols="6" class="caption">
              <table>
                <thead>
                  <tr>
                    <th>To</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{voucherDetail.customerName}}</td>
                  </tr>
                  <tr>
                    <td>(Ph : {{voucherDetail.customerPhone}})</td>
                  </tr>
                  <tr>
                    <td>{{voucherDetail.customerAddress}} {{voucherDetail.fromBranchName}} {{voucherDetail.fromBranchAddress}}</td>
                  </tr>
                </tbody>
              </table>
            </v-col>
            <v-col cols="12" class="fontCss mt-1">
              <table>
                <tr>
                  <th style="width: 25%">Item Name</th>
                  <td>{{voucherDetail.itemName}}</td>
                </tr>
                <tr>
                  <th>Item Weight</th>
                  <td>{{voucherDetail.weight}}</td>
                </tr>
                <tr>
                  <th>Item Value</th>
                  <td>{{voucherDetail.itemValue}}</td>
                </tr>
                <tr>
                  <th>Delivery Fee</th>
                  <td>{{voucherDetail.deliCost}}</td>
                </tr>
                <tr>
                  <th>Payment</th>
                  <td>{{voucherDetail.cutomerPayment}}</td>
                </tr>
              </table>
            </v-col>
            <v-col cols="6" class="text-left fontCss">{{itemId}}</v-col>
              <v-col cols="6" class="caption text-right">Issued by - {{profileName}}</v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-row no-gutters class="caption">
            <v-col md="2" cols="2">
              <img :src="file" ref="cropper" style="height: 10vh;" />
            </v-col>
            <v-col md="6" cols="8" class="text-left px-3">
              <v-row no-gutters>
                <v-col cols="12" class="first-heading-font">{{company.companyName}}</v-col>
                <v-col cols="12">{{company.address}}</v-col>
                <v-col cols="12">{{company.phoneNo}}</v-col>
                <v-col cols="12">{{company.email}}</v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6" class="caption pr-1">
              <table>
                <thead>
                  <tr>
                    <th>From</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{voucherDetail.osName}}</td>
                  </tr>
                  <tr>
                    <td>(Ph : {{voucherDetail.osPhone}})</td>
                  </tr>
                  <tr>
                    <td>{{voucherDetail.osAddress}} {{voucherDetail.osTownship}} {{voucherDetail.osCity}}</td>
                  </tr>
                </tbody>
              </table>
            </v-col>
            <v-col cols="6" class="caption">
              <table>
                <thead>
                  <tr>
                    <th>To</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{voucherDetail.customerName}}</td>
                  </tr>
                  <tr>
                    <td>(Ph : {{voucherDetail.customerPhone}})</td>
                  </tr>
                  <tr>
                    <td>{{voucherDetail.customerAddress}} {{voucherDetail.fromBranchName}} {{voucherDetail.fromBranchAddress}}</td>
                  </tr>
                </tbody>
              </table>
            </v-col>
            <v-col cols="12" class="fontCss mt-1">
              <table>
                <tr>
                  <th style="width: 25%">Item Name</th>
                  <td>{{voucherDetail.itemName}}</td>
                </tr>
                <tr>
                  <th>Item Weight</th>
                  <td>{{voucherDetail.weight}}</td>
                </tr>
                <tr>
                  <th>Item Value</th>
                  <td>{{voucherDetail.itemValue}}</td>
                </tr>
                <tr>
                  <th>Delivery Fee</th>
                  <td>{{voucherDetail.deliCost}}</td>
                </tr>
                <tr>
                  <th>Payment</th>
                  <td>{{voucherDetail.cutomerPayment}}</td>
                </tr>
              </table>
            </v-col>
            <v-col cols="6" class="text-left fontCss">{{itemId}}</v-col>
              <v-col cols="6" class="caption text-right">Issued by - {{profileName}}</v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import companyInfoService from "../service/CompanyInfoService";
import voucherService from "../service/VoucherService";
import axios from "../config";
export default {
  data() {
    return {
      file: "",
      company: {},
      todayDate: "",
      voucherDetail: {},
      itemId: 0,
      isShowTable: false,
    };
  },
  mounted: function () {
    let itemId = this.$route.query.itemId;
    if (itemId == undefined || itemId == null) {
      return;
    }
    this.itemId = Number(itemId);
    if (this.itemId != 0) {
      var today = new Date();

      var date =
        today.getDate() +
        "/" +
        (today.getMonth() + 1) +
        "/" +
        today.getFullYear() +
        " " +
        today.getHours() +
        ":" +
        today.getMinutes();
      this.todayDate = date;
      this.getVoucherData(this.itemId);
      this.getCompanyInfo();
    }
  },

  computed: {
    profileName: function () {
      if (this.$store.state.userAccount == null) {
        return "";
      } else {
        return this.$store.state.userAccount.profileName;
      }
    },
  },
  methods: {
    getVoucherData: function (itemId) {
      voucherService.getVoucherDataForPrint(itemId).then((response) => {
        this.voucherDetail = response;
      });
    },
    printSaleVoucher: function () {
      window.print();
    },
    getCompanyInfo: function () {
      companyInfoService.getCompanyInfo().then((response) => {
        this.company = Object.assign({}, response);
        this.file = `${axios.defaults.baseURL}/companyLogo/${response.logo}`;
      });
    },
  },
};
</script>
<style scoped>
.fontCss {
  font-size: 0.60rem !important;
}
table {
  width: 100%;
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 0.3em;
}
.envlope table {
  border-collapse: collapse;
}

.envlope table,
.envlope th,
.envlope td {
  border: 1px solid black;
}
.envlope th,
.envlope td {
  width: 150px;
}

.box {
  padding: 10px;
  border: 0.5em solid transparent;
  border-image: 16
    repeating-linear-gradient(
      -45deg,
      red 0,
      red 1em,
      transparent 0,
      transparent 2em,
      #58a 0,
      #58a 3em,
      transparent 0,
      transparent 4em
    );
}
</style>